interface ServiceCardProps {
  name: string;
  description: string;
  price: number;
  originalPrice: number;
  duration: string;
  rating: number;
  reviewCount: number;
  store: string;
  image: string;
}

export default function ServiceCard({
  name,
  description,
  price,
  originalPrice,
  duration,
  rating,
  reviewCount,
  store,
  image,
}: ServiceCardProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer transition-all duration-300 hover:border-primary-200">
      <div className="relative h-48 overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
        />
        <div className="absolute top-3 left-3">
          <span className="bg-primary-500 text-white text-xs font-medium px-2 py-1 rounded-md">
            {duration}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-foreground-900 text-sm mb-1 line-clamp-1">{name}</h3>
        <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{description}</p>
        <div className="flex items-center gap-1 mb-2">
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <i
                key={i}
                className={`text-xs ${
                  i < Math.floor(rating) ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                }`}
              ></i>
            ))}
          </div>
          <span className="text-xs text-foreground-500 ml-1">{rating}</span>
          <span className="text-xs text-foreground-400">({reviewCount})</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-baseline gap-1.5">
            <span className="text-base font-bold text-primary-500 whitespace-nowrap">¥{price}</span>
            <span className="text-xs text-foreground-400 line-through whitespace-nowrap">¥{originalPrice}</span>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{store}</span>
        </div>
      </div>
    </div>
  );
}